export const LANG_STORAGE_KEY = "preferred_lang";

export function getInitialLang() {
  try {
    const url = new URL(window.location.href);
    const urlLang = url.searchParams.get("lang");

    if (urlLang === "tr" || urlLang === "en") {
      return urlLang;
    }
  } catch (_) {}

  try {
    const saved = localStorage.getItem(LANG_STORAGE_KEY);

    if (saved === "tr" || saved === "en") {
      return saved;
    }
  } catch (_) {}

  try {
    const navLang = (navigator.language || "en").toLowerCase();
    return navLang.startsWith("tr") ? "tr" : "en";
  } catch (_) {
    return "tr";
  }
}

export function persistLangSideEffects(lang) {
  const safeLang = lang === "en" ? "en" : "tr";

  try {
    document.documentElement.setAttribute("lang", safeLang);
  } catch (_) {}

  try {
    const url = new URL(window.location.href);
    url.searchParams.set("lang", safeLang);
    window.history.replaceState({}, "", url.toString());
  } catch (_) {}

  try {
    localStorage.setItem(LANG_STORAGE_KEY, safeLang);
  } catch (_) {}
}

export function withLangInUrl(hash = "", lang = "tr") {
  try {
    const safeLang = lang === "en" ? "en" : "tr";
    const safeHash = typeof hash === "string" ? hash : "";

    const url = new URL(window.location.href);

    if (safeHash) {
      url.hash = safeHash.startsWith("#") ? safeHash : `#${safeHash}`;
    }

    url.searchParams.set("lang", safeLang);

    return `${url.pathname}${url.search}${url.hash}`;
  } catch (_) {
    const safeLang = lang === "en" ? "en" : "tr";
    const safeHash =
      typeof hash === "string" && hash.length > 0
        ? hash.startsWith("#")
          ? hash
          : `#${hash}`
        : "";

    return `?lang=${safeLang}${safeHash}`;
  }
}

export function getDict(lang) {
  const tr = {
    nav: {
      home: "Ana Sayfa",
      solutions: "Çözümlerimiz",
      useCases: "Kullanım Alanları",
      about: "Hakkımızda",
      ourMilestones: "Kilometre Taşlarımız",
      collaborators: "Partnerlerimiz",
      ourTeam: "Ekibimiz",
      contact: "İletişim",
      cta: "Bize Ulaşın",
      logoAlt: "Kene Teknoloji logosu",
      ariaLogo: "Ana sayfaya dön",
      ariaToggle: "Menüyü aç veya kapat",
      ariaPrimary: "Ana gezinme",
      ariaLanguage: "Dil seçimi",
      ariaMobileMenu: "Mobil menü",
      homeHash: "#hero",
      solutionsHash: "#solutions",
      useCasesHash: "#use-cases",
      aboutHash: "#about",
      ourMilestonesHash: "#our-milestones",
      collaboratorsHash: "#collaborators",
      ourTeamHash: "#our-team",
      contactHash: "#contact",
    },

    about: {
      titlePrefix: "Biz",
      brand: "KENE Teknoloji",
      description:
        "KENE Teknoloji, su altı güvenliği ve kritik altyapı koruması için yenilikçi çözümler geliştiren savunma ve robotik şirketidir. Amasya/Merzifon merkezli yapımızla ileri mühendislik, yapay zekâ ve mekatroniği bir araya getirerek yüksek katma değerli otonom su altı sistemleri geliştiriyoruz.",
      visionTitle: "Vizyonumuz",
      visionText:
        "Su altı robotik sistemleri alanında çevik, yenilikçi ve rekabetçi yapısıyla küresel ölçekte önde gelen teknoloji şirketlerinden biri olmak.",
      missionTitle: "Misyonumuz",
      missionText:
        "Savunma, güvenlik ve kritik altyapı ihtiyaçlarına uyumlu, sürdürülebilir, çift kullanımlı ve ileri teknoloji çözümleri geliştirerek yüksek etki oluşturmak.",
      whatWeDoTitle: "Ne Yapıyoruz",
      whatWeDoText:
        "KENE Otonom Su Altı Robotları; sürü zekâsı, sessiz itki, elektromanyetik tutunma ve sensör füzyonu gibi kabiliyetlerle hem askeri hem de sivil görevlerde etkin çözümler sunar.",
    },

    cookie: {
      bannerTitle: "Çerez Tercihleri",
      bannerDescription:
        "Kene Teknoloji olarak web sitemizde size daha iyi bir deneyim sunabilmek için çerezler kullanıyoruz. Bu çerezler; sitenin temel çalışmasını sağlar, tercihlerinizi hatırlar, performans analizine yardımcı olur ve onay vermeniz halinde pazarlama/analitik amaçlarla kullanılabilir.",
      acceptAll: "Kabul Et",
      rejectOptional: "Reddet",
      settings: "Ayarlar",
      settingsTitle: "Çerez Tercihleri",
      settingsDescription:
        "Kene Teknoloji olarak, web sitemizde kullanılan çerezlerin kontrol edilmesine her zaman olanak sağlıyoruz. Tercihlerinizi düzenledikten sonra kaydedebilirsiniz.",
      preferencesTitle: "İşlevsellik Çerezleri",
      preferencesText:
        "Bu çerezler; dil tercihi, kullanıcı tercihleri ve site içi deneyimin iyileştirilmesi için kullanılır.",
      necessaryTitle: "Gerekli / Zorunlu Çerezler",
      necessaryText:
        "Bu çerezler sitenin çalışması için zorunludur. Oturum, güvenlik ve temel sayfa işlevleri için kullanılır ve kapatılamaz.",
      marketingAnalyticsTitle: "Pazarlama & Analitik Çerezleri",
      marketingAnalyticsText:
        "Bu çerezler site performansını ölçmek, kullanım eğilimlerini anlamak ve onay vermeniz halinde daha ilgili içerik sunmak için kullanılabilir.",
      cancel: "Vazgeç",
      save: "Kaydet",
      alwaysActive: "Her zaman aktif",
    },

    ourSolutions: {
      kicker: "Çözümlerimiz",
      osH2: "Çözümlerimiz",
      osSub:
        "Su altı görevleri, kritik altyapı denetimi ve ileri mühendislik ihtiyaçları için geliştirdiğimiz modüler çözümler.",
      primaryGroupTitle: "Ana Çözümler",
      capabilityGroupTitle: "Mühendislik Kabiliyetleri",
      autonomousSystems: "Otonom Su Altı Sistemleri",
      rndPrototyping: "Ar-Ge ve Prototipleme",
      cncManufacturing: "CNC ve Hassas Parça Üretimi",
      printingSolutions: "3D Yazıcı Çözümleri",
      energyBattery: "Enerji ve Batarya Sistemleri",
      roboticManipulator: "Robotik Kol ve Manipülatör Sistemleri",
      aiNavigation: "Yapay Zekâ Destekli Navigasyon Sistemleri",
      sonarSensor: "Sonar ve Sensör Entegrasyon Sistemi",
      compositeBody: "Kompozit Gövde ve Yapısal Tasarım",
    },

    useCases: {
      kicker: "Kullanım Alanları",
      title: "Saha ve Görev Senaryoları",
      subtitle:
        "Su altı operasyonları, denetim ve kritik altyapı görevlerinde kullanılabilecek başlıca senaryolar.",
      cardBadge: "Operasyon Senaryosu",
      prevAriaLabel: "Önceki kart",
      nextAriaLabel: "Sonraki kart",
      indicatorsAriaLabel: "Kart göstergeleri",
      indicatorLabel: "Kart",
      items: [
        {
          id: "port-shipyard",
          title: "Liman & Tersane Denetimi",
          text: "Rıhtım, iskele ve gemi altı denetimleri için hızlı saha kontrolü, görsel kayıt ve raporlama akışı.",
          imageAlt: "Liman ve tersane denetimi senaryosu",
          list: [
            "Gemi altı kontrol",
            "Rıhtım ve iskele inceleme",
            "Raporlama ve kayıt",
          ],
        },
        {
          id: "hull-cleaning",
          title: "Gemi Gövdesi Temizliği ve Bakım",
          text: "Biofouling temizliği, pervane ve gövde kontrol süreçlerinde operasyonel verimlilik sağlayan denetim desteği.",
          imageAlt: "Gemi gövdesi temizliği ve bakım senaryosu",
          list: [
            "Biofouling kontrol",
            "Pervane inceleme",
            "Bakım planı desteği",
          ],
        },
        {
          id: "offshore-energy",
          title: "Offshore Enerji ve Platform Muayenesi",
          text: "Platform ve deniz altyapısı muayenelerinde görsel veri toplama, ön değerlendirme ve kayıt süreçleri.",
          imageAlt: "Offshore enerji ve platform muayenesi senaryosu",
          list: [
            "Altyapı muayenesi",
            "Görsel kayıt",
            "Ön değerlendirme",
          ],
        },
        {
          id: "oil-platforms",
          title: "Deniz Petrol Platformları Denetimi",
          text: "Deniz petrol platformlarında su altı yapı kontrolü, bağlantı noktalarının incelenmesi ve operasyon öncesi teknik gözlem desteği sağlar.",
          imageAlt: "Deniz petrol platformları denetimi senaryosu",
          list: [
            "Su altı yapı denetimi",
            "Bağlantı ve hat kontrolü",
            "Teknik ön inceleme",
          ],
        },
        {
          id: "environmental-monitoring",
          title: "Çevresel İzleme",
          text: "Kirlilik, akıntı ve çevresel verilerin sahadan toplanması için ölçüm ve izleme desteği.",
          imageAlt: "Çevresel izleme senaryosu",
          list: [
            "Kirlilik gözlemi",
            "Akıntı izleme",
            "Veri toplama",
          ],
        },
        {
          id: "search-rescue",
          title: "Batık Arama ve Kurtarma Destek",
          text: "Arama ve kurtarma senaryolarında saha keşfi, görsel destek ve operasyon öncesi hızlı kontrol akışı.",
          imageAlt: "Batık arama ve kurtarma destek senaryosu",
          list: [
            "Saha keşfi",
            "Teknik ön inceleme",
            "Operasyon desteği",
          ],
        },
        {
          id: "insurance-class",
          title: "Sigorta, Klas ve Denetim Kurumları",
          text: "Denetim süreçlerinde standartlara uygun görsel kayıt, kontrol listesi yaklaşımı ve doğrulanabilir saha çıktıları.",
          imageAlt: "Sigorta, klas ve denetim kurumları senaryosu",
          list: [
            "Denetim desteği",
            "Dokümantasyon",
            "Standartlara uyum",
          ],
        },
      ],
    },

    hero: {
      alt: "Su altı sistemleri görseli",
      kicker: "Otonom Su Altı Sistemleri",
      title: "Kritik Altyapılar İçin Akıllı ve Otonom Su Altı Çözümleri",
      text: "Liman, tersane, gemi altı ve kritik deniz altyapılarında görev odaklı, yerli ve ileri mühendislik çözümleri geliştiriyoruz.",
      primaryCta: "Çözümlerimizi İnceleyin",
      secondaryCta: "İletişime Geçin",
    },

    contact: {
      h2: "İletişim",
      sub: "Bir sorunuz mu var? Aşağıdan bize yazın.",
      name: "Ad Soyad",
      email: "E-posta",
      message: "Mesajınız",
      send: "Gönder",
      sending: "Gönderiliyor…",
      infoTitle: "İletişim Bilgileri",
      addressLabel: "Adres",
      cityLine: "Amasya/Merzifon, Türkiye",
      emailLabel: "E-posta",
      emailValue: "info@keneteknoloji.com",
      hoursLabel: "Çalışma Saatleri",
      hoursValue: "Pzt–Cum, 09:00–18:00",
      nameRequired: "İsim gerekli.",
      emailRequired: "E-posta gerekli.",
      emailInvalid: "Geçerli bir e-posta girin.",
      messageRequired: "Mesaj gerekli.",
      sentOk: "Mesajınız başarıyla gönderildi.",
      sentFail: "Gönderilemedi. Lütfen daha sonra tekrar deneyin.",
      envMissing:
        "E-posta yapılandırması eksik. Lütfen yöneticinize bildirin.",
      envMissingShort: "E-posta yapılandırması eksik.",
      configMissing: "Konfigürasyon eksik. Gönderilemedi.",
      configMissingShort: "Konfigürasyon eksik. Gönderilemedi.",
      authError: "Yetkilendirme/Origin hatası. Ayarları kontrol edin.",
      serviceError:
        "Service/Template kimliği hatalı. Ayarları kontrol edin.",
      networkError:
        "Ağ/CORS hatası. Tarayıcı ağ kayıtlarını kontrol edin.",
      detailLabel: "Detay",
      botFieldLabel: "Bu alanı boş bırakın",
      mailTitle: "İletişim Formu",
    },

    collaborators: {
      kicker: "İş Ortaklarımız",
      title: "Partnerlerimiz",
      subtitle:
        "Savunma, enerji ve denizcilik sektörlerinde stratejik iş ortaklarımızla yenilikçi çözümler üretiyoruz.",
      cta: "İş Birliği İçin Ulaşın",
      empty: "Henüz partner eklenmedi.",
      ariaLabel: "Partnerlerimiz",
      partnerNames: {
        sahaIstanbul: "SAHA İstanbul",
        tubitak: "Tübitak",
        corumTeknopark: "Çorum Teknokent",
        amasyaUniversity: "Amasya Üniversitesi",
        fixConsulting: "Fix Consulting",
        grupOfis: "Grup Ofis",
        hakanKalıp: "Hakan Kalıp",
        gobel: "Göbel",
      },
    },

    ourTeam: {
      eyebrow: "Ekibimiz",
      status: "Güncelleniyor",
      title: "Güçlü, Disiplinli ve Çok Yönlü Bir Ekip",
      text: "Yazılım, elektronik, mekanik tasarım ve saha uygulamalarını bir araya getirerek su altı sistemleri için bütünleşik çözümler geliştiriyoruz.",
      preparingTitle: "Ekibimiz",
      note: "",
      members: [],
    },

    footer: {
      brand: "Kene Teknoloji",
      tagline: "SESSİZ • OTONOM • KARARLI",
      rightsReserved: "Tüm hakları saklıdır.",
      ariaLabel: "Site altbilgisi",
    },

    ourMilestones: {
      kicker: "Gelişim Yolculuğumuz",
      title: "Kilometre Taşlarımız",
      text: "Ar-Ge’den prototip testlerine, akademik iş birliklerinden teknoloji ekosistemine uzanan gelişim sürecimizin başlıca adımları.",
      items: [
        {
          year: "2024",
          title: "Ar-Ge Çalışmaları Başlaması",
          text: "Ar-Ge faaliyetlerimize başlandı.",
          icon: "bulb",
          color: "amber",
        },
        {
          year: "2025",
          title: "Şirket Kurulumu",
          text: "Şirketimizin resmi kuruluş süreci tamamlanarak faaliyetlerimize başlandı.",
          icon: "building",
          color: "orange",
        },
        {
          year: "2025",
          title: "Amasya Üniversitesi İşbirliği Protokolü",
          text: "Amasya Üniversitesi ile işbirliği protokolü imzalanarak akademik ve teknolojik ortaklık süreci başlatıldı.",
          icon: "globe",
          color: "green",
        },
        {
          year: "2025",
          title: "İlk Prototip Havuz Testi",
          text: "İlk prototip sistemimizin kontrollü havuz testleri başarıyla gerçekleştirildi.",
          icon: "chat",
          color: "red",
        },
        {
          year: "2026",
          title: "SAHA İstanbul Üyeliği",
          text: "Savunma, havacılık ve ileri teknoloji ekosisteminin önemli kümelenmelerinden SAHA İstanbul’a üye olundu.",
          icon: "chart",
          color: "cyan",
        },
        {
          year: "2026",
          title: "Çorum Teknokent",
          text: "Çorum Teknokent bünyesinde yer alınarak Ar-Ge ve girişimcilik faaliyetleri güçlendirildi.",
          icon: "puzzle",
          color: "purple",
        },
        {
          year: "2026",
          title: "KOSGEB Desteği",
          text: "Projemizin gelişimini desteklemek amacıyla KOSGEB desteği alındı.",
          icon: "gear",
          color: "magenta",
        },
        {
          year: "2026",
          title: "Teknogirişim Rozeti",
          text: "Yapılan inceleme ve değerlendirmeler sonucunda Teknogirişim Rozeti almaya hak kazanıldı.",
          icon: "badge",
          color: "indigo",
        },
        {
          year: "2026",
          title: "TÜBİTAK Proje Desteği Onayı",
          text: "Otonom su altı sistemleri alanındaki Ar-Ge projemiz TÜBİTAK değerlendirme sürecinden geçerek desteklenmeye hak kazandı.",
          icon: "award",
          color: "cyan",
        },
      ],
    },
  };

  const en = {
    nav: {
      home: "Home",
      solutions: "Solutions",
      useCases: "Use Cases",
      about: "About",
      ourMilestones: "Our Milestones",
      collaborators: "Partners",
      ourTeam: "Our Team",
      contact: "Contact",
      cta: "Contact Us",
      logoAlt: "Kene Teknoloji logo",
      ariaLogo: "Go to home page",
      ariaToggle: "Open or close menu",
      ariaPrimary: "Primary navigation",
      ariaLanguage: "Language selection",
      ariaMobileMenu: "Mobile menu",
      homeHash: "#hero",
      solutionsHash: "#solutions",
      useCasesHash: "#use-cases",
      aboutHash: "#about",
      ourMilestonesHash: "#our-milestones",
      collaboratorsHash: "#collaborators",
      ourTeamHash: "#our-team",
      contactHash: "#contact",
    },

    about: {
      titlePrefix: "About",
      brand: "KENE Technology",
      description:
        "KENE Technology is a defense and robotics company developing innovative solutions for underwater security and critical infrastructure protection. Headquartered in Amasya/Merzifon, we combine advanced engineering, artificial intelligence, and mechatronics to build high-value autonomous underwater systems.",
      visionTitle: "Our Vision",
      visionText:
        "To become one of the leading global technology companies in underwater robotic systems through an agile, innovative, and competitive approach.",
      missionTitle: "Our Mission",
      missionText:
        "To create high-impact outcomes by delivering sustainable, dual-use, and advanced technology solutions aligned with the needs of defense, security, and critical infrastructure sectors.",
      whatWeDoTitle: "What We Do",
      whatWeDoText:
        "KENE Autonomous Underwater Robots deliver effective solutions for both military and civilian missions with capabilities such as swarm intelligence, silent propulsion, electromagnetic adhesion, and sensor fusion.",
    },

    cookie: {
      bannerTitle: "Cookie Preferences",
      bannerDescription:
        "At Kene Technology, we use cookies on our website to provide you with a better experience. These cookies help the site function properly, remember your preferences, support performance analysis, and may be used for marketing/analytics purposes if you give consent.",
      acceptAll: "Accept",
      rejectOptional: "Reject",
      settings: "Settings",
      settingsTitle: "Cookie Preferences",
      settingsDescription:
        "At Kene Technology, we always allow you to manage the cookies used on our website. After updating your preferences, you can save them here.",
      preferencesTitle: "Functional Cookies",
      preferencesText:
        "These cookies are used for language selection, user preferences, and improving the overall site experience.",
      necessaryTitle: "Necessary / Required Cookies",
      necessaryText:
        "These cookies are required for the website to work properly. They are used for session, security, and core page functionality and cannot be disabled.",
      marketingAnalyticsTitle: "Marketing & Analytics Cookies",
      marketingAnalyticsText:
        "These cookies may be used to measure site performance, understand usage trends, and provide more relevant content if you give consent.",
      cancel: "Cancel",
      save: "Save",
      alwaysActive: "Always active",
    },

    ourSolutions: {
      kicker: "Solutions",
      osH2: "Our Solutions",
      osSub:
        "Modular solutions developed for underwater missions, critical infrastructure inspections, and advanced engineering needs.",
      primaryGroupTitle: "Core Solutions",
      capabilityGroupTitle: "Engineering Capabilities",
      autonomousSystems: "Autonomous Underwater Systems",
      rndPrototyping: "R&D and Prototyping",
      cncManufacturing: "CNC and Precision Part Manufacturing",
      printingSolutions: "3D Printing Solutions",
      energyBattery: "Energy and Battery Systems",
      roboticManipulator: "Robotic Arm and Manipulator Systems",
      aiNavigation: "AI-Assisted Navigation Systems",
      sonarSensor: "Sonar and Sensor Integration System",
      compositeBody: "Composite Hull and Structural Design",
    },

    useCases: {
      kicker: "Use Cases",
      title: "Field and Mission Scenarios",
      subtitle:
        "Key operational scenarios where our underwater systems can be used for inspection, monitoring, and critical infrastructure missions.",
      cardBadge: "Operation Scenario",
      prevAriaLabel: "Previous card",
      nextAriaLabel: "Next card",
      indicatorsAriaLabel: "Card indicators",
      indicatorLabel: "Card",
      items: [
        {
          id: "port-shipyard",
          title: "Port & Shipyard Inspection",
          text: "Fast field control, visual recording, and reporting workflow for quay, pier, and hull inspection operations.",
          imageAlt: "Port and shipyard inspection scenario",
          list: [
            "Hull inspection",
            "Quay and pier review",
            "Reporting and records",
          ],
        },
        {
          id: "hull-cleaning",
          title: "Hull Cleaning and Maintenance",
          text: "Inspection support that improves operational efficiency in biofouling cleaning, propeller inspection, and hull maintenance processes.",
          imageAlt: "Hull cleaning and maintenance scenario",
          list: [
            "Biofouling control",
            "Propeller inspection",
            "Maintenance planning support",
          ],
        },
        {
          id: "offshore-energy",
          title: "Offshore Energy and Platform Inspection",
          text: "Visual data collection, preliminary assessment, and documentation processes for offshore platforms and marine infrastructure inspections.",
          imageAlt: "Offshore energy and platform inspection scenario",
          list: [
            "Infrastructure inspection",
            "Visual recording",
            "Preliminary assessment",
          ],
        },
        {
          id: "oil-platforms",
          title: "Marine Oil Platform Inspection",
          text: "Provides underwater structural inspection, connection point review, and technical pre-operation observation support for marine oil platforms.",
          imageAlt: "Marine oil platform inspection scenario",
          list: [
            "Underwater structure inspection",
            "Connection and line checks",
            "Technical pre-operation review",
          ],
        },
        {
          id: "environmental-monitoring",
          title: "Environmental Monitoring",
          text: "Measurement and monitoring support for collecting field data related to pollution, currents, and environmental conditions.",
          imageAlt: "Environmental monitoring scenario",
          list: [
            "Pollution observation",
            "Current monitoring",
            "Data collection",
          ],
        },
        {
          id: "search-rescue",
          title: "Wreck Search and Rescue Support",
          text: "Field reconnaissance, visual support, and rapid pre-operation checks for search and rescue missions.",
          imageAlt: "Wreck search and rescue support scenario",
          list: [
            "Field reconnaissance",
            "Technical pre-inspection",
            "Operational support",
          ],
        },
        {
          id: "insurance-class",
          title: "Insurance, Class and Inspection Authorities",
          text: "Standards-compliant visual documentation, checklist-based control, and verifiable field outputs for inspection workflows.",
          imageAlt: "Insurance, class and inspection authorities scenario",
          list: [
            "Inspection support",
            "Documentation",
            "Compliance with standards",
          ],
        },
      ],
    },

    hero: {
      alt: "Underwater systems visual",
      kicker: "Autonomous Underwater Systems",
      title: "Smart and Autonomous Underwater Solutions for Critical Infrastructure",
      text: "We develop mission-focused, domestic, and advanced engineering solutions for ports, shipyards, ship hulls, and critical marine infrastructure.",
      primaryCta: "Explore Our Solutions",
      secondaryCta: "Contact Us",
    },

    contact: {
      h2: "Contact",
      sub: "Do you have a question? Send us a message below.",
      name: "Full Name",
      email: "Email",
      message: "Your Message",
      send: "Send",
      sending: "Sending…",
      infoTitle: "Contact Information",
      addressLabel: "Address",
      cityLine: "Amasya/Merzifon, Türkiye",
      emailLabel: "Email",
      emailValue: "info@keneteknoloji.com",
      hoursLabel: "Working Hours",
      hoursValue: "Mon–Fri, 09:00–18:00",
      nameRequired: "Name is required.",
      emailRequired: "Email is required.",
      emailInvalid: "Please enter a valid email address.",
      messageRequired: "Message is required.",
      sentOk: "Your message has been sent successfully.",
      sentFail: "Could not be sent. Please try again later.",
      envMissing:
        "Email configuration is missing. Please inform the administrator.",
      envMissingShort: "Email configuration is missing.",
      configMissing: "Configuration is missing. Could not send.",
      configMissingShort: "Configuration is missing. Could not send.",
      authError: "Authorization/Origin error. Please check the settings.",
      serviceError:
        "Service/Template ID is invalid. Please check the settings.",
      networkError:
        "Network/CORS error. Please check the browser network logs.",
      detailLabel: "Detail",
      botFieldLabel: "Leave this field empty",
      mailTitle: "Contact Form",
    },

    collaborators: {
      kicker: "Partners",
      title: "Our Partners",
      subtitle:
        "We build innovative solutions with our strategic partners in defense, energy, and maritime industries.",
      cta: "Contact for Collaboration",
      empty: "No partners have been added yet.",
      ariaLabel: "Our Partners",
      partnerNames: {
        sahaIstanbul: "SAHA Istanbul",
        tubitak: "Tübitak",
        corumTeknopark: "Çorum Technocity",
        amasyaUniversity: "Amasya University",
        fixConsulting: "Fix Consulting",
        grupOfis: "Grup Ofis",
        hakanKalıp: "Hakan Kalıp",
        gobel: "Göbel",
      },
    },

    ourTeam: {
      eyebrow: "Our Team",
      status: "Updating",
      title: "A Strong, Disciplined and Multidisciplinary Team",
      text: "We develop integrated solutions for underwater systems by bringing together software, electronics, mechanical design and field operations.",
      preparingTitle: "Our Team",
      note: "",
      members: [],
    },

    footer: {
      brand: "Kene Teknoloji",
      tagline: "SILENT • AUTONOMOUS • DETERMINED",
      rightsReserved: "All rights reserved.",
      ariaLabel: "Site footer",
    },

    ourMilestones: {
      kicker: "Our Growth Journey",
      title: "Our Milestones",
      text: "The key milestones in our journey, from research and prototype testing to academic collaboration and participation in the technology ecosystem.",
      items: [
        {
          year: "2024",
          title: "Start of R&D Activities",
          text: "Our research and development activities officially began.",
          icon: "bulb",
          color: "amber",
        },
        {
          year: "2025",
          title: "Company Establishment",
          text: "Our official company establishment process was completed and operations began.",
          icon: "building",
          color: "orange",
        },
        {
          year: "2025",
          title: "Amasya University Collaboration Protocol",
          text: "A collaboration protocol was signed with Amasya University, launching an academic and technological partnership.",
          icon: "globe",
          color: "green",
        },
        {
          year: "2025",
          title: "First Prototype Pool Test",
          text: "The controlled pool tests of our first prototype system were successfully completed.",
          icon: "chat",
          color: "red",
        },
        {
          year: "2026",
          title: "SAHA Istanbul Membership",
          text: "We became a member of SAHA Istanbul, one of the major clusters in the defense, aviation, and advanced technology ecosystem.",
          icon: "chart",
          color: "cyan",
        },
        {
          year: "2026",
          title: "Corum Technopark",
          text: "By joining Corum Technopark, our R&D and entrepreneurship activities were further strengthened.",
          icon: "puzzle",
          color: "purple",
        },
        {
          year: "2026",
          title: "KOSGEB Support",
          text: "KOSGEB support was received to accelerate the development of our project.",
          icon: "gear",
          color: "magenta",
        },
        {
          year: "2026",
          title: "Teknogirişim Badge",
          text: "Following the review and evaluation process, we became eligible to receive the Teknogirişim Badge.",
          icon: "badge",
          color: "indigo",
        },
        {
          year: "2026",
          title: "TÜBİTAK Project Support Approval",
          text: "Our R&D project in autonomous underwater systems successfully completed the TÜBİTAK evaluation process and became eligible for support.",
          icon: "award",
          color: "cyan",
        },
      ],
    },
  };

  return lang === "en" ? en : tr;
}